// extracted by mini-css-extract-plugin
module.exports = {"GiftCardResult":"styles_GiftCardResult__vbPuo","disabledText":"styles_disabledText__vlkWd","resultLabel":"styles_resultLabel__VNQ0g","resultValue":"styles_resultValue__6CWrz"};